﻿﻿﻿<div class="container-tab-lists">
    <maintenance-control-plan-menu (newEvent)="onNew()"></maintenance-control-plan-menu>
    <h2>{{title}}</h2>
    <div class="tab-body">
        <div class="tab-content">
            <maintenance-control-plan-list [list]="list" [newService]="newMode"></maintenance-control-plan-list>
        </div> <!--tab-body-->
    </div> <!--inner-tcontainer-tab-->
</div> <!--container-tab-lists-->